// import VueRouter, { RouteConfig } from 'vue-router'

const Layout = () => import('../views/Layout.vue')

export default [
  {
    path: '/system',
    name: 'system',
    component: Layout,
    meta: {
      title: '系统功能管理',
      icon: 'i-setting',
    },
    children: [],
  },
]
